import React, { Component } from "react"
import { Container, Modal, Row } from "react-bootstrap"
import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import Stage, { Exam, Investigation, Notification, SiteAssigned, Laboratory, Screen, Collect, MRO, Confirm, POCT } from "../../api/OrderResults/OrderResultModel/Stage"
import { Status } from "../../api/OrderResults/OrderResultModel/Status"
import FormatDate from "../../formatters/FormatDate"

const stageStatus = (status: Status): string => {
  switch (status.toString()) {
    case Status.None.toString(): return "status-none"
    case Status.Completed.toString(): return "status-completed"
    case Status.InProcess.toString(): return "status-in-progress"
    case Status.Alert.toString(): return "status-alert"
    case Status.NoStatus.toString(): return "status-no-status"
    default: return ""
  }
}

interface ModalStatusInfoProps {
  details: OrderResultRecord
  onHide: () => void
}

export default class ModalStatusInfo extends Component<ModalStatusInfoProps> {
  render() {
    const renderStatus = (status: OrderResultRecord) => {
      if (!status.Stages) {
        return <></>
      }
      return status.Stages.map((stage: Stage, key: number) => {
        let fields = []
        const header = (label: string) => <Row className={stageStatus(stage.StatusDetail.Status)} key={label + key}>{label}</Row>
        const field = (label: string, value: string | number): JSX.Element | null => value ? <Row key={label + key}>{label}: {value}</Row> : null
        if (stage.Name === "Investigation") {
          const detail = stage.StatusDetail as Investigation
          fields.push(header("INVESTIGATION"))
          fields.push(field("Title", detail.Title))
          fields.push(field("Date Order", FormatDate(detail.DateOrder)))
          fields.push(field("Reference ID", detail.ReferenceID))
          fields.push(field("Processed By", detail.ProcessedBy))
        }
        if (stage.Name === "Exam") {
          const detail = stage.StatusDetail as Exam
          fields.push(header("EXAM"))
          fields.push(field("Title", detail.Title))
          fields.push(field("Site Name", detail.SiteName))
          fields.push(field("Site Address", detail.SiteAddress))
          fields.push(field("Collection Date", FormatDate(detail.CollectionDate)))
          fields.push(field("Status", detail.Status))
        }
        if (stage.Name === "Notification") {
          const detail = stage.StatusDetail as Notification
          fields.push(header("NOTIFICATION"))
          fields.push(field("Title", detail.Title))
          fields.push(field("Notification Date", FormatDate(detail.NotificationDate)))
          fields.push(field("Recipient", detail.Recipient))
          fields.push(field("Method", detail.Method))
        }
        if (stage.Name === "Site Assigned") {
          const detail = stage.StatusDetail as SiteAssigned
          fields.push(header("SITE ASSIGNED"))
          fields.push(field("Title", detail.Title))
          fields.push(field("Site Name", detail.SiteName))
          fields.push(field("Site Address", detail.SiteAddress))
        }
        if (stage.Name === "Laboratory") {
          const detail = stage.StatusDetail as Laboratory
          fields.push(header("LABORATORY"))
          fields.push(field("Title", detail.Title))
          fields.push(field("Laboratory Name", detail.LaboratoryName))
          fields.push(field("Date Received", FormatDate(detail.DateReceived)))
          fields.push(field("Report Date", FormatDate(detail.ReportDate)))
        }
        if (stage.Name === "MRO") {
          const detail = stage.StatusDetail as MRO
          fields.push(header("MRO"))
          fields.push(field("Title", detail.Title))
          fields.push(field("Date Received", FormatDate(detail.DateReceived)))
          fields.push(field("MRO Status", detail.MROStatus))
        }
        if (stage.Name === "Collect") {
          const detail = stage.StatusDetail as Collect
          fields.push(header("COLLECT"))
          fields.push(field("Title", detail.Title))
          fields.push(field("Site Name", detail.SiteName))
          fields.push(field("Site Address", detail.SiteAddress))
          fields.push(field("Collection Date", FormatDate(detail.CollectionDate)))
          fields.push(field("Collection Status", detail.CollectionStatus))
        }
        if (stage.Name === "Screen") {
          const detail = stage.StatusDetail as Screen
          fields.push(header("SCREEN"))
          fields.push(field("Title", detail.Title))
          fields.push(field("Site Name", detail.SiteName))
          fields.push(field("Site Address", detail.SiteAddress))
          fields.push(field("Collection Date", FormatDate(detail.CollectionDate)))
        }
        if (stage.Name === "Confirm") {
          const detail = stage.StatusDetail as Confirm
          fields.push(header("CONFIRM"))
          fields.push(field("Title", detail.Title))
          fields.push(field("Site Name", detail.SiteName))
          fields.push(field("Site Address", detail.SiteAddress))
          fields.push(field("Collection Date", FormatDate(detail.CollectionDate)))
        }
        if (stage.Name === "POCT") {
          const detail = stage.StatusDetail as POCT
          fields.push(header("POCT Reported"))
          fields.push(field("Title", detail.Title))
        }
        return (
          <Container key={key} className={fields.length > 0 ? "pb-3" : ""}>
            {fields}
          </Container>
        )
      })
    }
    const status = this.props.details
    return (
      <Modal show onHide={this.props.onHide} dialogClassName="status-info" >
        <Modal.Header closeButton>
          <Modal.Title>STATUS INFORMATION</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {status ? renderStatus(status) : ""}
        </Modal.Body>
      </Modal>
    )
  }
}
